export default __webpack_public_path__ + "static/media/icon-forward-skip.042e098c.svg";